<template>
  <div class="container-update">
    <div class="alert-content">
      <i class="fas fa-user-graduate"></i>
      <h3>{{ $t("promotion.title") }}</h3>
      <p class="w-60 mx-auto">{{ $t("promotion.message") }}</p>
       
      <argon-button
        v-if="!isConfirmed"
        @click="ActivePromote"
        type="button"
        class="btn update-button"
       
        
        :loading="loading"
        :active="buttonActive || showConfirmation"
        :clickEvent="button"
      >
        <span> {{ $t("promotion.button") }}</span>
      </argon-button>
    </div>
  </div>
</template>
<script>
import { ActivePromote } from "@/utils/services";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import ArgonButton from "@/components/ArgonButton";

export default {
  name: "Promote-View",
  props: {
    newVersion: {
      type: String,
      required: true,
    },
  },
  components:{
  ArgonButton
  },
  data() {
    return {
      showMobileAlert: false,
      loadind: false,
      buttonActive: false,
      showConfirmation: false,
    };
  },

  methods: {
    async ActivePromote() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.buttonActive = true;

      try {
        let response = await ActivePromote();

        if (response.status === 200) {
          if (!this.showConfirmation) {
            this.showConfirmation = true;
            toast.success(this.$t("promote.success_promote"), {
              autoClose: 3000,
            });
            setTimeout(() => {
              window.location.reload();
            }, 4000);
          }
        }
      } catch (error) {
        console.error("Erreur lors de l'activation de la promotion :", error);
      } finally {
        this.loading = false;
        this.buttonActive = false;
        this.showConfirmation= false;
      }
    },
  },
};
</script>

<style scoped>
.container-update {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #111c44;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  pointer-events: auto;
  overflow: hidden;
}
.alert-content {
  padding: 2rem;
  max-width: 90%;
}
.alert-content i {
  font-size: 4rem;
  color: #75acff;
  margin-bottom: 1rem;
}
.alert-content h3 {
  color: #fff;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}
.alert-content p {
  color: #fff;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}
.update-button {
  background: #75acff;
  color: #00182b;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.update-button:hover {
  background: #91b9f5;
}
</style>
